import { Injectable } from '@angular/core';
import { Subject, Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChatSessionService {
  private profileSubject = new Subject<any>();
  private modalOpenSubject = new BehaviorSubject<boolean>(false);
  public modalOpen$ = this.modalOpenSubject.asObservable();

  openChat(profile: any): void {
    this.profileSubject.next(profile);
  }

  getNewChat$(): Observable<any> {
    return this.profileSubject.asObservable();
  }

  setModalOpen(isOpen: boolean): void {
    this.modalOpenSubject.next(isOpen);
  }
}
